import { Facet } from './Facet';

export class UIFacet extends Facet<{ Component: React.ComponentType }> {
}
